import { OccConfig } from '@spartacus/core';

export const organizationOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getAllUsers: '/users/${userId}/orgCustomers',
        getOrgUnitsRootNodeTree: '/users/${userId}/orgUnitsRootNodeTree',
      } as any,
    },
  },
};
